import { IconButton } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const Pagination = styled.div`
  display: flex;
  gap: 2px;
  justify-content: center;
`;

const PaginationPage = styled(IconButton)`
  background-color: transparent;
  border-radius: 2px;
  color: var(--color-fg-weaker);
  font-size: 12px;
  font-weight: 600;

  &:hover {
    background-color: var(--color-bg-weakest);
  }

  ${({ active }) =>
    active &&
    css`
      background-color: var(--color-bg-weakest);
      font-weight: 800;
    `}
`;

export { Pagination, PaginationPage };
